module.exports = __webpack_public_path__ + "assets/0b7ef5e515320587cb2972a1d81dee1b.ogv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hu/video.ogv
// module id = 348
// module chunks = 1